import { OriginTerminal, Terminal, Lang } from './terminal'
import { Log } from '../utilities/logger'

const parseItem = (item: string): Lang => {
  try {
    return JSON.parse(item)
  } catch (e) {
    return {}
  }
}

export const jsonTerminalParse = (data: OriginTerminal) => {
  try {
    const result: Terminal = {
      ...data,
      firstInstruction: parseItem(data.firstInstruction),
      secondInstruction: parseItem(data.secondInstruction),
    }
    return result
  } catch (e) {
    Log('json terminal parse error', e)
    return null
  }
}

export const jsonAllTerminalsParse = (data: OriginTerminal[]) => {
  return data.map((item) => jsonTerminalParse(item))
}

export const jsonTerminalSerialization = (data: Terminal) => {
  try {
    const result: OriginTerminal = {
      ...data,
      firstInstruction: JSON.stringify(data.firstInstruction),
      secondInstruction: JSON.stringify(data.secondInstruction),
    }
    return result
  } catch (e) {
    Log('json terminal serialization error', e)
    return null
  }
}
